/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".user-profile-title[_ngcontent-%COMP%]{color:#00a9a5}.kt-nav[_ngcontent-%COMP%]{margin:0;list-style:none;border:0;text-align:center;padding:0;color:#00a9a5}a.btn[_ngcontent-%COMP%]{margin-top:-10px}a.btn[_ngcontent-%COMP%]:hover{color:#007673}span.kt-header__topbar-username.user-profile-title[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
